import { IWidgetDataValidateResp } from "../../../Widgets/IWidgetDataValidateResp";
import _ from 'lodash';
import { JsonSchemaValidator } from '@Utils/JsonSchemaValidator';

/////////////////////////////////////////////////////////////////////////

export enum TimeSeriesChartType {
    line = 'line',
    scatter = 'scatter',
    bar = 'bar',
    lineWithPoints = 'line-points'
}

export interface TimeSeriesPortData {
    name: string;
    ticks: number[];
    data: number[];
    id: number;
    /**
     * Chart type
     */
    type?: string;
    backgroundColor?: string;

    /**
     * Dataset markers for event
     */
    markers?: TimeSeriesEventMarker[];
}

export interface TimeSeriesEventMarker {
    color?: string;
    label: string;
    tick: number;
}

/////////////////////////////////////////////////////////////////////////
export function TimeSeriesChartJsonSchemeValidator() {
    return JsonSchemaValidator.GetInstance(
        'TimeSeriesChartJsonSchemeValidator',
        {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    ticks: {
                        type: 'array',
                        items: {
                            type: ['number']
                        },
                    },
                    data: {
                        type: 'array',
                        items: {
                            type: ['number']
                        },
                    },
                    id: {
                        type: 'number',
                    },
                    name: {
                        type: 'string',
                    },
                    type: {
                        type: 'string'
                    },
                    backgroundColor: {
                        type: 'string',
                    },
                    markers: {
                        type: 'array',
                        items: {
                            type: 'object',
                            properties: {
                                tick: {
                                    type: 'number',
                                },
                                label: {
                                    type: 'string'
                                },
                                color: {
                                    type: 'string'
                                },
                            },
                            required: ['tick', 'label']
                        }
                    },
                },
                required: ['id', 'data', 'ticks', 'name', 'backgroundColor']
            },
            minItems: 0
        },
        null,
        (data: any): IWidgetDataValidateResp => {
            // Initialize response.
            let rsp: IWidgetDataValidateResp = {
                valid: true,
                errors: null
            };

            // Find the number of unequalities.
            let unequalities: number = 0;
            _.forEach(data as TimeSeriesPortData[], v => {
                if (v.ticks.length != v.data.length)
                    unequalities++;
            });

            // Warning if there are any unequalities.
            rsp.warning = unequalities > 0 ? (unequalities +
                ' unequal length' + (unequalities == 1 ? ' ' : 's ') +
                'between data and ticks arrays') : '';
            return rsp;
        }
    );
}